import * as React from 'react';

const BalloonSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="balloon_svg__eds-icon--balloon_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="balloon_svg__eds-icon--balloon_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M16.8 4.4c-1.3-1.3-3.1-1.9-4.9-1.9-1.8 0-3.5.6-4.9 1.9-2.7 2.6-2.7 6.8 0 9.4l3.8 3.7-1 3h1.6v2h1v-2H14l-1-3 3.8-3.7c2.7-2.6 2.7-6.8 0-9.4zm-5.5 15.1l.3-1h.6l.3 1h-1.2zm.6-2.4l-4.1-4c-1.2-1-1.8-2.4-1.8-4 0-1.5.6-2.9 1.7-4s2.6-1.7 4.1-1.7c1.6 0 3 .6 4.1 1.7 1.1 1.1 1.7 2.5 1.7 4s-.6 2.9-1.7 4l-4 4z"
        />
        <path
            className="balloon_svg__eds-icon--balloon_line"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M7.2 9.7h1c0-1.9 1.6-3.4 3.6-3.4v-1c-2.5 0-4.6 2-4.6 4.4z"
        />
    </svg>
);

BalloonSvg.displayName = 'BalloonSvg';
export default BalloonSvg;
